import { gtmDataLayerAdapter } from './gtm-data-layer-adapter';

export function trackPageView(pathname: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  gtmDataLayerAdapter.trackScreen(pathname);
}
